<template>
  <oie-header-state-message v-if="isImpersonating" @click="isImpersonatingAnonymous ? revertImpersonationAnonymous() : revertImpersonation()">
    <template #message>
      {{ composeAsCustomerText }}
    </template>
    <template #button-text>
      {{ tStatic('impersonatingSignOut') }}
    </template>
  </oie-header-state-message>
</template>

<script>
import { mapGetters } from 'vuex'
import utils from '@/core/utils'

export default {
  computed: {
    ...mapGetters('commerce', ['cart']),
    impersonating() {
      return this.clientModel.impersonating
    },
    isImpersonating() {
      return this.clientModel.impersonating !== null
    },
    isImpersonatingAnonymous() {
      return this.impersonating.anonymous
    },
    composeAsCustomerText() {
      const impersonatingAs = this.isImpersonatingAnonymous
        ? `"${this.tStatic('impersonatingAnonymousCustomer')}"`
        : this.impersonating.customerName && this.impersonating.fullName && this.impersonating.customerName.trim() !== this.impersonating.fullName.trim()
          ? `"${this.impersonating.customerNumber} - ${this.impersonating.fullName} | ${this.impersonating.customerName}"`
          : `"${this.impersonating.customerNumber} - ${this.impersonating.customerName}"`

      return `${this.tStatic('impersonatingSignedInAs')} ${impersonatingAs}`
    }
  },
  mounted() {
    // Make sure to clear the checkout store, for each new session
    if (utils.getQueryStringParam('clearCheckoutStore') === '1') {
      this.$store.dispatch('checkout/clearCheckout')
      const url = new URL(window.location.href)
      url.searchParams.delete('clearCheckoutStore')
      window.history.replaceState(null, '', url.toString())
    }
    const superUserMergeCart = utils.getQueryStringParam('superUserMergeCarts')
    if (superUserMergeCart) {
      const sourceMarket = utils.getQueryStringParam('sourceMarket')
      const customerHasCart = utils.getQueryStringParam('customerHasCart')
      setTimeout(() => {
        this.publish('modal.show.merge-cart-superuser',
          {
            showClose: false,
            sourceMarket: sourceMarket,
            customerHasCart: customerHasCart.toLowerCase() === 'true'
          })
      }, 300)
    }
  },
  methods: {
    async revertImpersonation() {
      await this.$store.dispatch('chat/endSessionForLogout')
      await this.$store.dispatch('myMachines/setGlobalMyMachinesSelection', {})
      await this.$store.dispatch('checkout/clearCheckout')
      window.location = '/mvcapi/se/sv/superuser/revertImpersonation'
    },
    async revertImpersonationAnonymous() {
      if (this.cart.rows.length === 0) {
        await this.$store.dispatch('chat/endSessionForLogout')
        await this.$store.dispatch('checkout/clearCheckout')
        window.location = '/mvcapi/se/sv/superuser/revertImpersonationAnonymous'
      } else {
        this.publish('modal.show.signout-cart-superuser',
          {
            showClose: false
          })
      }
    }
  }
}
</script>
